import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import arrMenu from "./../../constants/menuRoutes";

class Menu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMenuOpen: false,
      menus: arrMenu,
    };
  }

  openMenu = (toggle) => {
    this.setState({ isMenuOpen: toggle });
  };

  render() {
    let sActiveClass = " si-active";
    let menus = this.state.menus.map((menu, idx) => {
      return (
        <li key={menu.id}>
          <NavLink
            to={{
              pathname: menu.link,
            }}
            isActive={() => {
              return window.location.hash.includes(menu.link);
            }}
            activeClassName="si-active"
          >
            {menu.transKey}
          </NavLink>
        </li>
      );
    });
    return (
      // Navbar starts here
      <header className="si-main__container--fluid si-header__wrap">
        <div className="si-header__container">
          <div className="si-nav">
            <div className="si-nav__list">
              <ul>{menus}</ul>
            </div>

            <div className="si-nav__login">
              <div className="si-ad__wrap si-ad--top">
                <div className="si-ad__banner">
                  <span>Powered by</span>
                  <div className="si-ad--logo"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      // Navbar ends here
    );
  }
}

export default Menu;
